/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_4_TagInputs */

const en_mk_parts_4_tag = /** @type {(inputs: Mk_Parts_4_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04 — Memory`)
};

const id_mk_parts_4_tag = /** @type {(inputs: Mk_Parts_4_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`04 — Ingatan`)
};

/**
* | output |
* | --- |
* | "04 — Memory" |
*
* @param {Mk_Parts_4_TagInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_4_tag = /** @type {((inputs?: Mk_Parts_4_TagInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_4_TagInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_4_tag(inputs)
	return en_mk_parts_4_tag(inputs)
});